<!-- <yt-fw-side-menu></yt-fw-side-menu> -->
<yt-fw-app-content [CollapseWhenMenuVisible]="true"></yt-fw-app-content>